import { render, staticRenderFns } from "./WalletAddBalance.vue?vue&type=template&id=46fc356c"
import script from "./WalletAddBalance.vue?vue&type=script&lang=js"
export * from "./WalletAddBalance.vue?vue&type=script&lang=js"
import style0 from "./WalletAddBalance.vue?vue&type=style&index=0&id=46fc356c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports